import styled, { css } from 'styled-components';

export const PlanCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  border-radius: 12px;
  border: 1px solid #c4c2c2;
  padding: 24px;
  height: 100%;
`;

export const PlanFeatures = styled.ul`
  margin-left: 24px;
`;

export const PriceContainer = styled.div`
  position: relative;
  margin-top: 24px;
`;

export const Price = styled.div`
  display: flex;
  align-items: end;
  font-size: 36px;
  font-weight: 500;
  line-height: 44px;
  color: #217442;
`;

export const CrossedPrice = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #605b59;
  text-decoration: line-through;
`;

export const Title = styled.div<{ $fitContent?: boolean }>`
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  ${({ $fitContent }) =>
    $fitContent &&
    css`
      width: fit-content;
    `}
`;

export const Heading = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: #217442;
`;

export const Text = styled.li`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  list-style: none;

  b {
    color: #217442;
  }
`;
